// extracted by mini-css-extract-plugin
export var fileUpload = "_gj-1";
export var modalButton = "_gj-0";